import { post, getExFile, postFile } from "@utils/httpUtil";

export function getPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/questionnaire/getPageInfo`, data, config);
}
//病例活动分页查询
export function medicalRecordPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/activity/medicalRecord/page`, data, config);
}

//导出病例活动列表
export function exportMedicalRecord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return getExFile(`/activity/medicalRecord/export`, data, config);
}
//结束活动
export function endActivity(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/activity/medicalRecord/endActivity`, data, config);
}

// 批量导入邀约医生
export function importDoctorApi(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile(`/activity/importDoctor`, data, config);
}

// 下载导入失败医生列表  9
export function exportFailExcelApi(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return getExFile(`/medicine/excel/exportFailExcel`, data, config);
}

//保存/更新病例活动
export function medicalRecordSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/activity/medicalRecord/save`, data, config);
}

//病例活动详情
export function medicalRecordDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/activity/medicalRecord/detail`, data, config);
}

//根据活动id查询参与病例邀约活动的医生信息
export function pageActivityInvitationDoctor(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/activity/medicalRecord/pageActivityInvitationDoctor`, data, config);
}

export function listPvUvByActivityIds(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/activity/medicalRecord/listPvUvByActivityIds`, data, config);
}
//当前社区是否实行莲花清瘟病例;

export function lhqwMedicalCommunity(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/content/medicalRecord/lhqwMedicalCommunity`, data, config);
}
